import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiErrorClear } from '../../../global/ducks/base-api';
import { AuthenticatedState } from '../../../global/models/authenticated-model';
import { DemographicAppKeys } from '../../../global/models/demographics-model';
import { BaseAppState } from '../../../global/models/redux-state';
import { TcsmStates } from '../../../root/tcsm-model';
import { EmploymentState } from '../../arc/features/employment/employment-model';
import { clearAEInfo } from '../annual-enrollment-slice';
import { fetchAnnualEnrollment } from '../helpers/annual-enrollment-requests';
import { AnnualEnrollmentState } from '../models/annual-enrollment-models';

export function useAnnualEnrollmentInfo(app: DemographicAppKeys, reload?: boolean, retainState?: boolean) {
	const authenticatedState = useSelector<BaseAppState, AuthenticatedState>(state => state.authenticatedState);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	const annualEnrollmentState = useSelector<TcsmStates, AnnualEnrollmentState>(state => state.annualEnrollment[app]);
	const dispatch = useDispatch();

	const clientId = app === DemographicAppKeys.myCPG ? authenticatedState?.clientGuid : employmentState?.currentEmployee?.guid;
	const groupId = useSelector<TcsmStates, number>(state => state?.groupsState?.currentGroup?.group_id);

	useEffect(() => {
        if (clientId && (!annualEnrollmentState?.AEInfoLoaded || reload)) {
			fetchAnnualEnrollment(dispatch, app, clientId, false, groupId);
		}
	}, [clientId]);

	useEffect(() => {
		return function cleanup() {
			if (!retainState) {
				dispatch(apiErrorClear());
				dispatch(clearAEInfo(app));
			}
		};
	}, []);

	return annualEnrollmentState.AEInfoLoaded;
}